import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const SquareList: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.89355 5.41077H8.51855"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.89355 10.5894H8.51855"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.89355 8H11.1078"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.179 1.78577H2.82185C2.24984 1.78577 1.78613 2.24948 1.78613 2.82148V13.1786C1.78613 13.7506 2.24984 14.2143 2.82185 14.2143H13.179C13.751 14.2143 14.2147 13.7506 14.2147 13.1786V2.82148C14.2147 2.24948 13.751 1.78577 13.179 1.78577Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
